@let colorsVal = previewColors();

<rt-heading>{{ 'tl.team_members.general_settings.company_theme.heading' | translate }} </rt-heading
><br />
<span>{{ 'tl.team_members.general_settings.company_theme.description' | translate }}</span>

<div class="grid" layout margin-top-small-x>
  <div class="preview">
    <rt-heading variant="subheading" margin-bottom-small-x>{{
      'tl.team_members.general_settings.company_theme.preview_view.title' | translate
    }}</rt-heading>
    <div class="preview-body" appShellTheme>
      <tlc-navigation-link
        [isActive]="true"
        [isChild]="false"
        [isExpanded]="false"
        [minimized]="false"
        [href]="'#'"
        [testId]="'theme-config-active'"
        [label]="
          'tl.team_members.general_settings.company_theme.preview_view.clicked_link' | translate
        "
      />
      <tlc-navigation-link
        [isActive]="false"
        [isChild]="false"
        [isExpanded]="false"
        [minimized]="false"
        [href]="'#'"
        [testId]="'theme-config-inactive-1'"
        [label]="'tl.team_members.general_settings.company_theme.preview_view.link' | translate"
      />
      <tlc-navigation-link
        [isActive]="false"
        [isChild]="false"
        [isExpanded]="false"
        [minimized]="false"
        [href]="'#'"
        [testId]="'theme-config-inactive-2'"
        [label]="'tl.team_members.general_settings.company_theme.preview_view.link' | translate"
      />
    </div>
  </div>

  <div class="setup">
    <rt-heading variant="subheading" margin-bottom-small-x>{{
      'tl.team_members.general_settings.company_theme.setup_view.title' | translate
    }}</rt-heading>
    <div class="controls">
      @for (control of controls; track control) {
        <div class="control">
          <div
            [rtColorPicker]="colorsVal![control]!"
            [cpAlphaChannel]="'disabled'"
            (colorPickerChange)="updatePreview(control, $event)"
          >
            <div
              [style.background]="colorsVal![control]!"
              margin-bottom-small-x
              class="control-color-preview"
            ></div>
            <span class="label">{{ labels[control] }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <rt-button (click)="resetTheme()" variant="outline">
    {{ 'tl.team_members.general_settings.company_theme.actions.reset_theme' | translate }}
  </rt-button>

  <rt-button (click)="saveTheme()" variant="secondary">
    {{ 'tl.team_members.general_settings.company_theme.actions.save_theme' | translate }}
  </rt-button>
</div>
